import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Search from './Components/Search/Search';
import UploadeExcelFile from './Components/TwoWheeler/UploadeExcelFile';
import Uplodelaptopfile from './Components/Search/Uplodelaptopfile';
import Login from './Components/Login/Login';
import { AuthProvider } from './Components/AuthContext';
import ProtectedRoute from './Components/ProtectedRoute';
import { InputProvider } from './Components/Context';
import EmployeeSearch from './Components/EmployeeSearch';
import EmployeeDetails from './Components/EmployeeDetails/EmployeeDetails';
import AddAsset from './Pages/AddAssest/AddAsset';
import MyAssets from './Pages/MyAssets/MyAssets';
import AdminAssets from './Pages/AdminAssets/AdminAssets';
import AddAsset1 from './Pages/AddAssest/AddAsset1';
import StateAssetsSummary from './Pages/AdminAssets/StateAssetsSummary';
import QuarterlyMailPanel from './Components/QuarterlyMailPanel/QuarterlyMailPanel';
import ChangePassword from './Pages/ChangePassword/ChangePassword';
// import 'bootstrap/dist/css/bootstrap.min.css';
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <InputProvider>
        <BrowserRouter>
        
          <Routes>
            <Route path="/uplodevehichal" element={<UploadeExcelFile />} />
            <Route path="/uplodelaptop" element={<Uplodelaptopfile />} />

            {/* Use ProtectedRoute for protected paths */}
            <Route path="/Search" element={<ProtectedRoute element={<Search />} />} />

            <Route path="/" element={<Login />} />
            <Route path="/employeesearch" element={< EmployeeSearch/>} />
            <Route path="/employeedetails" element={<EmployeeDetails />} />

            {/* // Add Asset Route */}
            <Route path="/addasset" element={<AddAsset />} />
            <Route path="/addasset1" element={<AddAsset1 />} />
            <Route path="/myassets" element={<MyAssets />} />
            <Route path="/adminassets" element={<AdminAssets />} /> 
            <Route path="/admin-assets-summary" element={<StateAssetsSummary />} />
            <Route path="/quarterly-mail-panel" element={<QuarterlyMailPanel />} />

            <Route path="/change-password" element={<ChangePassword />} />
            {/* Fallback route for undefined paths */}
            <Route path="*" element={<h1>404 Not Found</h1>} />

          </Routes>
          
        </BrowserRouter>
        </InputProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
